/** Model list */
export const MODELS_ENDPOINT = '/models';
export const OFFERS_ENDPOINT = '/offer';
export const DISCLAIMER_ENDPOINT = '/disclaimer';
export const VEHICLE_ENDPOINT = '/variant-slug';
export const SME_DESCRIPTIONS_ENDPOINT = '/sme-content';
export const BODY_ENDPOINT = '/vehicle-type';
export const MAKE_ENDPOINT = '/make';
export const FUEL_ENDPOINT = '/fuel-type';
export const RANGE_ENDPOINT = '/range';
export const FILTER_ENDPOINT = '/search';